import React, { useState } from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import DisclaimerText from '../DisclaimerText';

import SignupAgeGateModal from '../SignupAgeGateModal';

import {
  FacebookButton,
  GoogleButton,
  EmailButton,
  SIGN_UP,
  FACEBOOK,
  GOOGLE,
  EMAIL
} from '../AccountAuthButton';

const LANDING_PAGE = 'landing_page';
const PRIVATE_ACTIVITY = 'private_activity';

const AccountSignupForm = ({ authorizationUrls, locale, page }) => {
  const [openModal, setOpenModal] = useState(false);
  const [signupOption, setSignupOption] = useState(null);

  const I18nPrefix = 'strava.landing_page';

  const handleOnClick = (option) => {
    if (option === EMAIL) {
      const url = authorizationUrls[EMAIL];
      const separator = url.indexOf('?') === -1 ? '?' : '&';
      window.location = url.concat(separator).concat('v2=true');
      return;
    }
    setOpenModal(true);
    setSignupOption(option);
  };

  const handleModalDobSubmit = () => {
    setOpenModal(false);
    window.location = authorizationUrls[signupOption];
  };

  const orDivider = (
    <div className={styles.hr}>
      <div className={styles.hrText}>{I18n.t(`${I18nPrefix}.or`)}</div>
    </div>
  );

  return (
    <>
      <FacebookButton type={SIGN_UP} onClick={() => handleOnClick(FACEBOOK)} />

      <GoogleButton type={SIGN_UP} onClick={() => handleOnClick(GOOGLE)} />

      {page === LANDING_PAGE && orDivider}

      <EmailButton type={SIGN_UP} onClick={() => handleOnClick(EMAIL)} />

      <DisclaimerText showLoginOption={page === LANDING_PAGE} />

      {page === PRIVATE_ACTIVITY && orDivider}

      <SignupAgeGateModal
        open={openModal}
        onDismissCallback={() => {
          setOpenModal(false);
        }}
        locale={locale}
        onSuccessCallback={handleModalDobSubmit}
      />
    </>
  );
};
AccountSignupForm.propTypes = {
  page: PropTypes.oneOf([LANDING_PAGE, PRIVATE_ACTIVITY]).isRequired,
  authorizationUrls: PropTypes.shape({
    google: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired,
  locale: PropTypes.string.isRequired
};

export default AccountSignupForm;
